import type { RequestContext, Client } from "../client";
import type { LicensedFeature } from "./licensedFeatures";
// Formatted in the "Request Enterprise Feature Trial" Workato recipe for downstream use.
type FeatureAvailableForTrial = Extract<LicensedFeature, "GlobalDeploymentFreeze" | "PriorityTask" | "JiraServiceManagementIntegration" | "ServiceNowIntegration">;
interface RequestFeatureTrialCommand {
    TypeOfFeature: FeatureAvailableForTrial;
}
export async function requestFeatureTrial(command: RequestFeatureTrialCommand, client: Client, requestContext: RequestContext): Promise<void> {
    return await client.post(requestContext, "~/bff/featuretrial/request-trial", command);
}
